export const config = {
  getprojects: "/v0/collection/collection-list",
  getStakes: "/v0/stakingList/stakingList-list",
  addStake: "/v0/staking/addStakingConnection-details",
  postCollection: "/v0/collection/addCollectionAndNft"
};



